<template lang="pug">
#app
  router-view
</template>

<script>
export default {
  name: 'App',
  components: {},
  data () {
    return {
      //
    }
  }
}
</script>
<style lang='stylus'>
@import './stylus/reset.styl'
@import './stylus/main.styl'
#app
  width 100%
  height 100%
.fade-enter-active, .fade-leave-active
  transition all .2s
.fade-enter, .fade-leave-to
  opacity 0
</style>
